import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ smooth = true, delay = 0 }) => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      if (hash) {
        // If hash is present, scroll to that element
        const element = document.getElementById(hash.replace("#", ""));
        if (element) {
          element.scrollIntoView({ behavior: smooth ? "smooth" : "auto" });
          return;
        }
      }

      // Default: Scroll to top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: smooth ? "smooth" : "auto",
      });
    };

    if (delay > 0) {
      setTimeout(scrollToTop, delay);
    } else {
      scrollToTop();
    }
  }, [pathname, search, hash, smooth, delay]);

  return null;
};

export default ScrollToTop;